// Prices the web shows before the API has said (fallbacks and the mock). The API's own numbers always win; these
// follow core's dated prices (core/src/pricing.ts PRICE_CHANGES) so a fallback never shows an old number.
// prices.test.ts checks them against core.

/** cost audit (decided 2026-10-30): a script, a revision or a Suno pack is 5 credits, 10 from this moment (UTC). */
export const SCRIPT_PRICE_CHANGE = { from: "2027-01-01T00:00:00Z", before: 5, after: 10 } as const;

/** A script, a revision or a Suno pack at `now`. */
export function scriptCredits(now: Date = new Date()): number {
  return now.getTime() >= Date.parse(SCRIPT_PRICE_CHANGE.from) ? SCRIPT_PRICE_CHANGE.after : SCRIPT_PRICE_CHANGE.before;
}
